import React from 'react';
import { X } from 'lucide-react';

export const ImageModal = ({ image, onClose }) => (
    <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content">
            <button className="close-modal" onClick={onClose}>
                <X size={20} />
            </button>
            <img src={image} alt="Enlarged view" />
        </div>
    </div>
);